import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { mapElementClass } from '../../../common/utils/element.utils';
import { ControlError } from '../ControlError';
;
var ModalPdf = function (_a) {
    var label = _a.label, frontOptions = _a.frontOptions, error = _a.error, touched = _a.touched, value = _a.value;
    var height = frontOptions.height || window.innerHeight - 200;
    var _b = useState(false), showModal = _b[0], setShowModal = _b[1];
    var onToggleModal = function (status) {
        setShowModal(status);
    };
    return (React.createElement("div", { className: mapElementClass(frontOptions) },
        React.createElement(Button, { icon: "far fa-file-pdf", label: label, onClick: onToggleModal.bind(null, true), className: frontOptions.className, style: frontOptions.style }),
        showModal,
        React.createElement(ControlError, { error: error, touched: touched }),
        React.createElement(Dialog, { visible: showModal, header: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 PDF", onHide: onToggleModal.bind(null, false), className: "ModalGroup", style: { width: '85%' } },
            React.createElement("iframe", { title: "PDF Viewer", src: value, width: "100%", height: height }))));
};
export default ModalPdf;
//# sourceMappingURL=ModalPdf.js.map